import React, { useState } from 'react';

const FareEstimate = ({ vehicle, distance, service }) => {
  const [showBreakdown, setShowBreakdown] = useState(false);

  const vehicleRates = {
    bike: { base: 50, perKm: 15, label: 'Bike' },
    boda: { base: 80, perKm: 20, label: 'Boda Boda' },
    tuktuk: { base: 120, perKm: 25, label: 'Tuk Tuk' },
    car: { base: 200, perKm: 35, label: 'Car' }
  };

  const rate = vehicleRates?.[vehicle] || vehicleRates?.boda;
  const dist = distance || 3.2;
  const baseFare = rate?.base;
  const distanceCharge = Math.round(rate?.perKm * dist);
  const serviceFee = Math.round((baseFare + distanceCharge) * 0.05);
  const totalFare = baseFare + distanceCharge + serviceFee;

  const isSurge = Math.random() > 0.7;
  const surgeMultiplier = isSurge ? 1.3 : 1;
  const finalFare = Math.round(totalFare * surgeMultiplier);

  return (
    <div className="bg-white rounded-2xl border border-[#0a1628]/10 overflow-hidden shadow-sm">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3.5 bg-gradient-to-r from-[#0a1628] to-[#1a365d]">
        <div>
          <p className="text-xs text-white/60 font-medium">Estimated Fare</p>
          <div className="flex items-baseline gap-2 mt-0.5">
            <span className="text-2xl font-bold text-[#ffd700]">KSh {finalFare}</span>
            {isSurge && (
              <span className="text-xs bg-orange-500/20 text-orange-300 px-2 py-0.5 rounded-full font-medium">
                1.3x surge
              </span>
            )}
          </div>
        </div>
        <div className="text-right">
          <p className="text-xs text-white/60">Distance</p>
          <p className="text-sm font-bold text-white">{dist} km</p>
          <p className="text-xs text-white/50 mt-0.5">~{Math.round(dist * 3)} min</p>
        </div>
      </div>
      {/* Breakdown Toggle */}
      <button
        onClick={() => setShowBreakdown(!showBreakdown)}
        className="w-full flex items-center justify-between px-4 py-3 hover:bg-[#0a1628]/3 transition-colors"
      >
        <span className="text-sm font-medium text-[#0a1628]/70">Fare breakdown</span>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className={`w-4 h-4 text-[#0a1628]/40 transition-transform duration-300 ${showBreakdown ? 'rotate-180' : ''}`}
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
      {/* Breakdown Details */}
      {showBreakdown && (
        <div className="px-4 pb-4 space-y-2 border-t border-[#0a1628]/8">
          <div className="pt-3 space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-[#0a1628]/60">Base fare ({rate?.label})</span>
              <span className="font-medium text-[#0a1628]">KSh {baseFare}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-[#0a1628]/60">Distance ({dist} km × KSh {rate?.perKm})</span>
              <span className="font-medium text-[#0a1628]">KSh {distanceCharge}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-[#0a1628]/60">Service fee (5%)</span>
              <span className="font-medium text-[#0a1628]">KSh {serviceFee}</span>
            </div>
            {isSurge && (
              <div className="flex justify-between text-sm">
                <span className="text-orange-500">Surge pricing (1.3x)</span>
                <span className="font-medium text-orange-500">+KSh {finalFare - totalFare}</span>
              </div>
            )}
            <div className="h-px bg-[#0a1628]/10 my-1"></div>
            <div className="flex justify-between text-sm font-bold">
              <span className="text-[#0a1628]">Total</span>
              <span className="text-[#0a1628]">KSh {finalFare}</span>
            </div>
          </div>
          {isSurge && (
            <div className="flex items-start gap-2 p-2.5 bg-orange-50 rounded-xl mt-2">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4 text-orange-500 flex-shrink-0 mt-0.5">
                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
              <p className="text-xs text-orange-700">High demand in your area. Prices are temporarily higher.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FareEstimate;
